if (typeof jQuery != "undefined") {
    (function(window, document, jQuery) {
        "use strict";

        var Enrich = function(target) {
            var $target,
                id,
                config = {
                    namespace: "js--enrich",
                    value: { valuta: false, accepted: null }
                };

            var init = function(target) {
                $target = jQuery(target);
                id = $target.attr("id");
                if (!id) {
                    id = _randomId();
                    $target.attr("id", id);
                }
                jQuery.extend(config, $target.data("enrich"));
                enrichType();
            };

            var enrichType = function() {
                // for ex. inputrange
                var type = $target[0].tagName;
                type +=
                    typeof $target[0].type !== "undefined"
                        ? $target[0].type
                        : "";
                type = type.toLowerCase();

                switch (type) {
                    case "inputrange":
                        _enrich_inputrange();
                        break;
                }
            };

            // ENRICHERS
            var _enrich_inputrange = function() {
                // add a value span
                var valueSpan = $(
                    '<output for="' +
                        id +
                        '" class="' +
                        config.namespace +
                        '__value"></output>'
                );
                $target.addClass(config.namespace + "__hasValueOutput");
                $target.after(valueSpan);

                var updateValSpan = function() {
                    var val = $target.val();
                    valueSpan.html(_transform_value(val));
                };

                // add min, max, steps
                if (config.value.accepted !== null) {
                    $target.attr("step", _math_gcd(config.value.accepted));
                    $target.attr("min", config.value.accepted[0]);
                    $target.attr(
                        "max",
                        config.value.accepted[config.value.accepted.length - 1]
                    );

                    var datalistId = _randomId();
                    var $datalist = jQuery(
                        '<datalist id="' + datalistId + '"></datalist>'
                    );
                    $target.attr("list", datalistId).after($datalist);

                    // find nearest
                    for (
                        var i = 0, c = config.value.accepted.length;
                        i < c;
                        i++
                    ) {
                        $datalist.append(
                            $(
                                "<option>" +
                                    config.value.accepted[i] +
                                    "</option>"
                            )
                        );
                    }
                }

                // events
                var onChange = function(ev) {
                    _morph_accepted();
                    updateValSpan();
                };

                $target.on("change input ", onChange);
                $target
                    .closest("form")
                    .on("ZZ-cancel-edit-toggle-item", onChange);

                // trigger change
                onChange();
            };

            // HELPERS
            var _transform_value = function(val) {
                if (config.value.valuta) {
                    val = "&euro; " + parseFloat(val).toFixed(2);
                    val = "" + val.split(".").join(",");
                }

                return val;
            };

            var _morph_accepted = function() {
                if (
                    config.value.accepted !== null &&
                    config.value.accepted.length >= 1
                ) {
                    var i, c, dist, bestDist, closestVal;
                    var val = $target[0].value;

                    if (
                        config.value.accepted.indexOf("" + val) >= 0 ||
                        config.value.accepted.indexOf(+val) >= 0
                    ) {
                        return true;
                    }
                    // find nearest
                    for (i = 0, c = config.value.accepted.length; i < c; i++) {
                        dist = Math.abs(+val - +config.value.accepted[i]);
                        if (
                            typeof bestDist === "undefined" ||
                            dist < bestDist
                        ) {
                            bestDist = dist;
                            closestVal = config.value.accepted[i];
                        }
                    }
                    $target.val(closestVal);
                }
            };
            // finds greatest common divider in array
            // ex [10,25,100] results in 5
            var _math_gcd = function(o) {
                if (!o.length) {
                    return 0;
                }
                for (var r, a, i = o.length - 1, b = o[i]; i; ) {
                    for (a = o[--i]; (r = a % b); a = b, b = r);
                }
                return b;
            };

            init(target);
        };

        var _randomId = function() {
            var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz".split(
                ""
            );

            var str = "";
            for (var i = 0; i < 32; i++) {
                str += chars[Math.floor(Math.random() * chars.length)];
            }
            return str;
        };

        jQuery(function() {
            jQuery(".js--enrich").each(function(i, el) {
                Enrich(el);
            });
        });
    })(window, document, jQuery);
}
